<div class="edit-customer-root">
  <div class="edit-customers-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ "SURVEYS_INSTALLATIONS.INSTALL_DETAILS" | translate }}
        </div>
        <div class="slrn">
          {{ selectedInstallation.dtName | hasValue }}
        </div>
        <div class="slrn">
          {{ selectedInstallation.dtNumber | hasValue }}
        </div>
        <div [ngClass]="selectedInstallation.installationStatus">
          {{ selectedInstallation.installationStatus == 'AwaitingApproval' ? ('COMMON.ASSET_STATUS.AWAITING_APPROVAL' | translate) : selectedInstallation.installationStatus }}
        </div>
      </div>
      <div class="user-address">
        <div *ngIf="!hasCimDataIntegration">{{ selectedInstallation.address | hasValue }}</div>
      </div>
    </div>
    <div class="action-buttons">
      <button class="btn btn-header"
        *ngIf="(selectedInstallation.installationStatus == 'Rejected' || selectedInstallation.installationStatus == 'Approved') && permissionsService.isDtMeterInstallationRecallAllowed"
        (click)="recall()">{{ 'COMMON.RECALL' | translate }}</button>
      <div class="submit-actions"
        *ngIf="(selectedInstallation.installationStatus == 'Submitted' || selectedInstallation.installationStatus == 'Resubmitted') && permissionsService.isDtMeterInstallationApproveRejectAllowed">
        <div class="row">
          <div class="col-6">
            <button class="btn btn-outline-danger" data-bs-toggle="modal" data-bs-target="#dtRejectModal">
              {{ 'COMMON.REJECT' | translate }}
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#dtApproveModal">
              {{ 'COMMON.APPROVE' | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="submit-actions"
        *ngIf="selectedInstallation.installationStatus == 'Approved' && permissionsService.isDtMeterInstallationAcceptDeclineAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment">
        <div class="row">
          <div class="col-6">
            <button class="btn btn-outline-danger" data-bs-toggle="modal" data-bs-target="#dtDeclineModal">
              {{ 'COMMON.DECLINE' | translate }}
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#dtAcceptModal">
              {{ 'COMMON.ACCEPT' | translate }}
            </button>
          </div>
        </div>
      </div>
      <button *ngIf="selectedInstallation.installationStatus == 'AwaitingApproval' && permissionsService.isDtMeterInstallationRecallAwaitingApprovalAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment"
        class="btn btn-header" data-bs-toggle="modal" data-bs-target="#dtRecallModal">
        {{ 'COMMON.RECALL' | translate }}
      </button>
    </div>
  </div>
  <div class="edit-customers-body">
    <div class="card container main-col" *ngIf="selectedInstallation.installationStatus == 'AwaitingApproval'">
      <div class="row">
        <div class="col-4 header-title">
          {{ 'INSTALLATIONS.APPROVAL_INFO' | translate }}
        </div>
        <div class="col-8">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ 'INSTALLATIONS.INVOICE.VENDOR' | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.vendor | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ 'INSTALLATIONS.INVOICE.METER_PRICE' | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.meterPrice | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ 'INSTALLATIONS.INSTALLATION_DATE' | translate }}
        </div>
        <div class="col-8">
          {{ (selectedInstallation.installationDate | date:'longDate') | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ 'INSTALLATIONS.INVOICE.PERIOD' | translate }}
        </div>
        <div class="col-8">
          {{ (selectedInstallation.installationDate | date:'MMMM, y') | hasValue }}
        </div>
      </div>
    </div>
    <div class="card container main-col">
      <div class="row">
        <div class="col-4 header-title">
          {{ "SURVEYS_INSTALLATIONS.DT_INFO" | translate }}
        </div>
        <div class="col-8">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ "COMMON.MBC_DETAILS.METER_STATUS" | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.meterStatus | hasValue }}
        </div>
      </div>
      <div class="row" *ngIf="!hasCimDataIntegration">
        <div class="col-4">
          {{ "TRANSFORMERS.DT_TYPE" | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.dtType | hasValue }}
        </div>
      </div>
    </div>
    <div class="card container main-col">
      <div class="row">
        <div class="col-4 header-title">
          {{ "SURVEYS_INSTALLATIONS.FEEDER_INFO" | translate }}
        </div>
        <div class="col-8">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.feederNumber | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          {{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}
        </div>
        <div class="col-8">
          {{ selectedInstallation.feederName | hasValue }}
        </div>
      </div>
    </div>
    <div class="card container main-col">
      <div class="row">
        <div class="col-4 header-title">
          {{ "COMMON.BU.SINGLE" | translate }}/{{
          "COMMON.UT.SINGLE" | translate
          }}
        </div>
        <div class="col-8">
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{ "COMMON.BU.SINGLE" | translate }}</div>
        <div class="col-8">
          {{ selectedInstallation.regionName | hasValue }}
        </div>
      </div>
      <div class="row">
        <div class="col-4">{{ "COMMON.UT.SINGLE" | translate }}</div>
        <div class="col-8">
          {{ selectedInstallation.areaName | hasValue }}
        </div>
      </div>
    </div>
  </div>
  <!-- OLD METER INFO -->
  <div class="edit-customers-header" style="margin-top: 2rem">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ "SURVEYS_INSTALLATIONS.OLD_METER_INFO" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_STATUS" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterStatus | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.OLD" | translate }}
            {{ "COMMON.MBC_DETAILS.METER_MAKE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterMake | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.OLD_METER_NO" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterNumber | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.OLD" | translate }}
            {{ "COMMON.TABLE_HEADERS.METER_TYPE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterType | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.OLD" | translate }}
            {{ "COMMON.MBC_DETAILS.METER_CONDITION" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterCondition | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.KWH_READING_OLD_METER" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.kwhReadingOldMeter | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.OLD_METER_BOX_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterBoxSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.OLD_METER_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldMeterSeal | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.OLD_TTB_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldTTBSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.OLD_CT_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.oldCTSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="col-3"></div>
      <div class="col-3"></div>
    </div>
  </div>
  <!-- NEW METER INFO -->
  <div class="edit-customers-header" style="margin-top: 2rem">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ "SURVEYS_INSTALLATIONS.NEW_METER_INFO" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_NO" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterNumber | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_TYPE.SINGLE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterType | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_MAKE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterMake | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_MODEL.SINGLE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterModel | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.METER_RATING.SINGLE" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterRating | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.NEW_CT_BOX_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newCTBoxSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.NEW_TTB_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newTTBSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.NEW_METER_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterSeal | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.NEW_METER_BOX_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newMeterBoxSeal | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.CT_RATING" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newCTRating | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.TAG_SERIAL_NUMBER" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.tagSerialNumber | hasValue }}
          </div>
        </div>
      </div>
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.INSTRUMENT_SERIAL_NUMBER" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.instrumentSerialNumber | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-3">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.MBC_DETAILS.VT_RATING" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.newVTRating | hasValue }}
          </div>
        </div>
      </div>
      <div class="col-3"></div>
      <div class="col-3"></div>
      <div class="col-3"></div>
    </div>
  </div>
  <!-- IMAGES -->
  <div class="edit-customers-header" style="margin-top: 2rem">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ "SURVEYS_INSTALLATIONS.LOC_IMAGES" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="location-images">
    <div class="row">
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.METER_READING_PIC" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('ReadingOnMeter')">
            <img alt="Meter reading image" [src]="getImageUrl('ReadingOnMeter')" (click)="showImage('ReadingOnMeter')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('ReadingOnMeter')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4" *ngIf="hasOldMeter">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.OLD_METER_BOX_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('OldMeterBoxSeal')">
            <img alt="Old meter box seal image" [src]="getImageUrl('OldMeterBoxSeal')" (click)="showImage('OldMeterBoxSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('OldMeterBoxSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4" *ngIf="hasOldMeter">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.OLD_METER_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('OldMeterSeal')">
            <img alt="Old meter seal image" [src]="getImageUrl('OldMeterSeal')" (click)="showImage('OldMeterSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('OldMeterSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="location-images">
    <div class="row">
      <div class="card container col-4" *ngIf="hasOldMeter">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.OLD_TTB_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('OldTTBSeal')">
            <img alt="Old TTB seal image" [src]="getImageUrl('OldTTBSeal')" (click)="showImage('OldTTBSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('OldTTBSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4" *ngIf="hasOldMeter">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.OLD_CT_SEAL" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('OldCTSeal')">
            <img alt="Old CT seal image" [src]="getImageUrl('OldCTSeal')" (click)="showImage('OldCTSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('OldCTSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.INSTALL_IN_PROGRESS" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('InstallationInProgressImage')">
            <img alt="Installation in progress image" [src]="getImageUrl('InstallationInProgressImage')" (click)="showImage('InstallationInProgressImage')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('InstallationInProgressImage')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="location-images">
    <div class="row">
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.NEW_CT_SEAL_PIC" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('CTSeal')">
            <img alt="New CT seal image" [src]="getImageUrl('CTSeal')" (click)="showImage('CTSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('CTSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.NEW_TTB_SEAL_PIC" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('TTBSeal')">
            <img alt="New TTB seal image" [src]="getImageUrl('TTBSeal')" (click)="showImage('TTBSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('TTBSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.NEW_METER_SEAL_PIC" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('MeterSeal')">
            <img alt="New meter seal image" [src]="getImageUrl('MeterSeal')" (click)="showImage('MeterSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('MeterSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="location-images">
    <div class="row">
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.NEW_METER_BOX_SEAL_PIC" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('MeterBoxSeal')">
            <img alt="New meter box seal image" [src]="getImageUrl('MeterBoxSeal')" (click)="showImage('MeterBoxSeal')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('MeterBoxSeal')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.FRONT_VIEW_METER_INSTALLATION" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('FrontInstallationImage')">
            <img alt="Front view of meter installation image" [src]="getImageUrl('FrontInstallationImage')" (click)="showImage('FrontInstallationImage')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('FrontInstallationImage')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.NEW_METER_CONNECTION" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('NewMeterAndConnection')">
            <img alt="New meter and its connection image" [src]="getImageUrl('NewMeterAndConnection')" (click)="showImage('NewMeterAndConnection')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('NewMeterAndConnection')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="location-images">
    <div class="row">
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "INSTALLATIONS.DETAILS.VOLTAGE_CABLE_TERMINATION" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('VoltageCableTermination')">
            <img alt="Voltage cable termination before insulation image" [src]="getImageUrl('VoltageCableTermination')" (click)="showImage('VoltageCableTermination')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('VoltageCableTermination')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="col-4"></div>
      <div class="col-4"></div>
    </div>
  </div>
  <!-- SIGNATURE & COMMENTS -->
  <div class="edit-customers-header" style="margin-top: 2rem">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ "SURVEYS_INSTALLATIONS.SIGNATURE_AND_COMMENTS" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row">
      <div class="card container col-4">
        <div class="row">
          <div class="col header-title-text">
            {{ "SURVEYS_INSTALLATIONS.INSTALLER_SIGNATURE" | translate }}
          </div>
        </div>
        <div class="row">
          <div *ngIf="getImageUrl('FieldRepSignature')">
            <img alt="Installer signature image" [src]="getImageUrl('FieldRepSignature')" (click)="showImage('FieldRepSignature')" data-bs-toggle="modal"
              data-bs-target="#modalImage" />
          </div>
          <div *ngIf="!getImageUrl('FieldRepSignature')">
            <label class="disabled-label">
              <img src="../../../../assets/missing_image.png" alt="Missing image" />
            </label>
          </div>
        </div>
      </div>
      <div class="col-4"></div>
      <div class="col-4"></div>
    </div>
  </div>
  <div class="customer-survey-body">
    <div class="row" style="width: 98.5%">
      <div class="card container col-12">
        <div class="row">
          <div class="col header-title-text">
            {{ "COMMON.COMMENT" | translate }}
          </div>
        </div>
        <div class="row">
          <div class="green-text">
            {{ selectedInstallation.comments | hasValue }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ==================== USER ACTIVITY SECTION ==================== -->
  <div class="customer-survey-body" *ngIf="
          selectedInstallation.installationStatus == 'Submitted' ||
          selectedInstallation.installationStatus == 'Approved' ||
          selectedInstallation.installationStatus == 'Rejected'
        ">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="edit-customers-header" style="margin-top: 2rem">
            <div class="user-header-info">
              <div class="user-info">
                <div class="name">{{ 'SURVEYS.DETAILS.USER_ACTIVITY' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row tb-border" style="margin-left: 0.5rem">
          <table class="table table-striped">
            <thead>
              <th>{{ 'HISTORY.DATE_TIMESTAMP' | translate }}</th>
              <th>{{ 'HISTORY.ACTION' | translate }}</th>
              <th>{{ 'COMMON.COMMENT' | translate }}</th>
              <th>{{ 'COMMON.USER.SINGLE' | translate }}</th>
            </thead>
            <tbody>
              <tr *ngFor="let history of selectedInstallation.installationHistory">
                <td>{{ history.timeStamp | date:'dd/MM/yyyy HH:mm' | hasValue }}</td>
                <td>{{ history.action | hasValue }}</td>
                <td>{{ history.comment | hasValue }}</td>
                <td>{{ history.user | hasValue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url"
            [thumbImage]="selectedImage?.url" [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">
            &lt;
          </button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">
            &gt;
          </button>
        </div>
        <div class="image-info" *ngIf="selectedImage?.physicalAddress || selectedImage?.lastUpdateTime">
          <div class="info-row" *ngIf="selectedImage?.physicalAddress">
            <span class="label">{{ 'COMMON.ADDRESS' | translate }}:</span>
            <span class="value">{{ selectedImage?.physicalAddress }}</span>
          </div>
          <div class="info-row" *ngIf="selectedImage?.latitude && selectedImage?.longitude">
            <span class="label">{{ 'COMMON.GEOLOCATION' | translate }}:</span>
            <span class="value">{{ selectedImage?.latitude }} {{ selectedImage?.longitude }}</span>
            <div class="map-icon" (click)="isImageMapVisible = !isImageMapVisible">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" data-bs-toggle="modal"
                data-bs-target="#showImageMap">
                <path
                  d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                  fill="#026962" />
              </svg>
            </div>
          </div>
          <div class="info-row" *ngIf="selectedImage?.lastUpdateTime">
            <span class="label">{{ 'COMMON.DATE_AND_TIME' | translate }}:</span>
            <span class="value">{{ selectedImage?.lastUpdateTime | date: 'dd/MM/yyyy hh:mm a' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dtApproveModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'INSTALLATIONS.DETAILS.APPROVE' | translate }}
        </h5>
      </div>
      <div>
        <div>
          {{ 'INSTALLATIONS.DETAILS.CONFIRM' | translate }}
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-outline-danger" style="width: 100%" data-bs-dismiss="modal">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-success" style="width: 100%" data-bs-dismiss="modal" (click)="approve()">
              {{ 'COMMON.APPROVE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dtRejectModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'INSTALLATIONS.DETAILS.REJECT' | translate }}
        </h5>
      </div>
      <div>
        <form id="dtRejectForm" ngNativeValidate (submit)="reject()">
          <div class="form-item form-floating mb-3">
            <select id="dtRejectOption" class="form-select" (change)="onOptionChange($event)">
              <option [value]="'capturedUser'"> {{ 'COMMON.REJECT_OPTIONS.CAPTURED_USER' | translate }} </option>
              <option [value]="'fieldAgent'"> {{ 'COMMON.REJECT_OPTIONS.FIELD_AGENT' | translate }} </option>
            </select>
          </div>
          <div *ngIf="rejectToOption === 'fieldAgent'" class="form-item form-floating mb-3">
            <div class="form-floating form-item">
              <input type="text" name="filterText" [(ngModel)]="filterText" class="form-control filter-field"
                [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="dtFloatingInput"
                (ngModelChange)="filterMobileUsers()" placeholder=" " />
              <label for="dtFloatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

              <div class="filtered-agent-list" *ngIf="filterText && filterText.length > 2 && isDropdownOpened">
                <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)" *ngFor="let u of mobileUsers">
                  {{ u.firstName }} {{ u.lastName }}
                </div>
              </div>
            </div>
          </div>
          <div>
            {{ 'INSTALLATIONS.DETAILS.REASON' | translate }}
          </div>
          <div style="padding: 10px">
            <textarea required rows="10" cols="50" name="note" [(ngModel)]="rejectionNote" class="form-control"></textarea>
          </div>
          <div class="row">
            <div class="col-6">
              <button type="button" data-bs-dismiss="modal" style="width: 100%" class="btn btn-outline-danger">
                {{ 'COMMON.CANCEL' | translate }}
              </button>
            </div>
            <div class="col-6">
              <button type="submit" class="btn btn-danger" style="width: 100%">
                {{ 'COMMON.REJECT' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dtAcceptModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'INSTALLATIONS.ACCEPT_TITLE' | translate }}
        </h5>
      </div>
      <div>
        <div>
          {{ 'INSTALLATIONS.ACCEPT_PROMPT' | translate }}
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-outline-danger" style="width: 100%" data-bs-dismiss="modal">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-success" style="width: 100%" data-bs-dismiss="modal" (click)="accept()">
              {{ 'COMMON.ACCEPT' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dtDeclineModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'INSTALLATIONS.DECLINE_TITLE' | translate }}
        </h5>
      </div>
      <div>
        <form id="declineForm" ngNativeValidate (submit)="decline()">
          <div [innerHTML]="'INSTALLATIONS.DECLINE_PROMPT' | translate"></div>
          <div style="padding: 10px">
            <textarea required rows="10" cols="50" name="declineNote" [(ngModel)]="declineNote" class="form-control"></textarea>
          </div>
          <div class="row">
            <div class="col-6">
              <button type="button" data-bs-dismiss="modal" style="width: 100%" class="btn btn-outline-danger">
                {{ 'COMMON.CANCEL' | translate }}
              </button>
            </div>
            <div class="col-6">
              <button type="submit" class="btn btn-danger" style="width: 100%">
                {{ 'COMMON.DECLINE' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dtRecallModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'INSTALLATIONS.RECALL_TITLE' | translate }}
        </h5>
      </div>
      <div>
        <div>
          {{ 'INSTALLATIONS.RECALL_PROMPT' | translate }}
        </div>
        <div class="row">
          <div class="col-6">
            <button type="button" class="btn btn-outline-danger" style="width: 100%" data-bs-dismiss="modal">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn btn-success" style="width: 100%" data-bs-dismiss="modal" (click)="recall()">
              {{ 'COMMON.RECALL' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
